import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import {
  ArrowLeftIcon,
} from '@heroicons/react/24/outline';
import useAuthStore from '../../store/authStore';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { forgotPassword, isLoading } = useAuthStore();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async ({ email }) => {
    const res = await forgotPassword({ email });

    if (res.success) {
      toast.success('We sent an OTP to your email.');
      navigate('/verify-otp', { state: { email, type: 'reset' } });
    } else {
      toast.error(res.error || 'Failed to send reset email.');
    }
  };

  return (
    <div className="w-full">
      <div className="text-left mb-8">
        <h2 className="text-3xl font-bold text-white mb-2 tracking-tight">Forgot Password?</h2>
        <p className="text-gray-400 font-medium tracking-tight">
          Enter your email and we'll send you a one-time code to reset your password.
        </p>
      </div>

      <form className="space-y-8" onSubmit={handleSubmit(onSubmit)}>
        <div className="space-y-1.5">
          <label className="block text-sm font-bold text-gray-300 ml-1">Email</label>
          <div className="relative">
            <input
              {...register('email', {
                required: 'Email is required',
                pattern: { value: /^\S+@\S+$/i, message: 'Invalid email' },
              })}
              type="email"
              className={`block w-full px-5 py-3.5 bg-[#1A1F26] border ${errors.email ? 'border-red-500' : 'border-white/5'} rounded-[1rem] text-white placeholder-gray-500 focus:ring-4 focus:ring-primary-500/10 focus:border-primary-500 transition-all shadow-lg text-sm`}
              placeholder="Your Email"
            />
          </div>
          {errors.email && <p className="mt-1 text-xs font-semibold text-red-500 ml-1">{errors.email.message}</p>}
        </div>

        <div className="pt-2">
          <button
            type="submit"
            disabled={isLoading}
            className="w-full flex justify-center py-3.5 px-6 rounded-[1rem] shadow-[0_20px_40px_-12px_rgba(79,70,229,0.4)] text-base font-bold text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-4 focus:ring-primary-500/30 disabled:opacity-50 disabled:cursor-not-allowed transition-all active:scale-[0.98]"
          >
            {isLoading ? (
              <div className="w-6 h-6 border-3 border-white/30 border-t-white rounded-full animate-spin"></div>
            ) : (
              'Send'
            )}
          </button>
        </div>

        <p className="text-center pt-8">
          <Link to="/login" className="text-xs font-bold text-gray-400 hover:text-primary-500 transition-colors inline-flex items-center">
            <ArrowLeftIcon className="h-4 w-4 mr-2" />
            Back to login
          </Link>
        </p>
      </form>
    </div>
  );
};

export default ForgotPassword;
